// Takvim günlerindeki müzakere işareti (mobil components/profile/helpers/dayMarkers).
// Katılınan müzakere günü "done", planlı ama katılınmamış gün "planned".

/**
 * Ay kaydından gün → müzakere durumu haritası. Katılım, günün etkinliklerindeki
 * muzakereId'den; planlı günler muzakereDates'ten. Yapılmış olan planlının
 * üstüne yazılır, tersi olmaz.
 */
export function muzakereMarkers(month) {
  const map = {};
  if (!month) return map;
  for (const day of month.dailyLogs || []) {
    const events = day?.events || day?.log?.dailyEvents || [];
    if (day?.date && events.some((e) => e && e.muzakereId)) map[day.date] = "done";
  }
  for (const date of month.muzakereDates || []) {
    if (date && map[date] !== "done") map[date] = "planned";
  }
  return map;
}

/** O gün kılınan kaza toplamı (günlük kayıttaki kazaPrayed). */
function kazaTotal(day) {
  const counts = day?.log?.kazaPrayed || day?.kazaPrayed || null;
  if (!counts) return 0;
  return Object.values(counts).reduce((sum, n) => sum + (Number(n) || 0), 0);
}

/** Takvim günlerindeki kaza işareti: o gün en az bir kaza kılındıysa true. */
export function kazaMarkers(month) {
  const map = {};
  for (const day of month?.dailyLogs || []) {
    if (day?.date && kazaTotal(day) > 0) map[day.date] = true;
  }
  return map;
}
